module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAABE0lEQVR42qWTT0/CQBDF99im/409oiGEoBGxRA8c/Eie+VJw0w8FoqhETPSy/l6yNakBu5FJXnZ2d97M7LzWWGv/DVmW5/ksy7Ib42HEVmBOfGHiOB6yeSqKYpskydlfxDRN+8S9Eb+GfG1kOD0O34ElwWAXMQzDDqRPFaHgReOSg1Jk4XcHEE/qO/lmlwVBcKrMrrXKJT3HfwVfrqv95mawBiuS3LEuWTdRFI2Mj2nykB7VJuszg5oYX6PKJaSFI69A5Vu1J+nAC/5UT9AMJFPbe0sn2Vat1zPQXjJJrgbhYKmo0nXt2X3vk0ySS7L9JJfjhvPBOm4Z5EiyST5wpe/1COeeJLfGwyQb8Q/EHx/0S34DddShlcMAODUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = 165
// module chunks = 35783957827783 112966903596346 114276838955818